/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_RegenerateInputs */



/**
* | output |
* | --- |
* | "Write it again" |
*
* @param {Meeting_Report_RegenerateInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_regenerate = /** @type {((inputs?: Meeting_Report_RegenerateInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_RegenerateInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Opnieuw maken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Refaire")
	return /** @type {LocalizedString} */ ("Write it again")
});